jQuery(document).ready(function() {
  jQuery(".awards-floating").hide(); //ボタンを非表示にする
  jQuery(window).on("scroll", function() {
    let scrollTop = jQuery(window).scrollTop(); // スクロール上部の位置
    let areaTop = jQuery("#a-awards").offset().top; // 対象エリアの上部の位置
    let areaBottom = areaTop + jQuery("#a-awards").innerHeight();
    if (scrollTop > areaTop && scrollTop < areaBottom) {
      jQuery(".awards-floating").fadeIn(); //ボタンがフェードインする
    } else {
      jQuery(".awards-floating").fadeOut(); //ボタンがフェードアウトする
    }

    scrollHeight = jQuery(document).height(); //ドキュメントの高さ
    scrollPosition = jQuery(window).height() + jQuery(window).scrollTop(); //現在地
    footHeight = jQuery("footer").innerHeight(); //止めたい位置の高さ(今回はfooter)
    oldHeight = jQuery(".old-list").innerHeight();
    sfHeight = jQuery(".sf-linkbox").innerHeight();
    stopHeight = footHeight + oldHeight + sfHeight;
    if (scrollHeight - scrollPosition <= stopHeight) {
      //ドキュメントの高さと現在地の差がfooterの高さ以下の時
      jQuery(".awards-floating").css({
        position: "absolute" //pisitionをabsoluteに変更
      });
    } else {
      //それ以外の場合は
      jQuery(".awards-floating").css({
        position: "fixed" //固定表示
      });
    }
  });
});
